import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { CrudService } from "src/app/Services/crud.service";
declare var Razorpay: any;

@Component({
    selector: "app-transaction-detail",
    templateUrl: "./transaction-detail.component.html",
    standalone: false
})
export class TransactionDetailComponent implements OnInit {
  data: any;
  loading = true;
  constructor(
    private translateService: TranslateService,
    private toastr: ToastrService,
    private crudService: CrudService,
    private route: ActivatedRoute
  ) {
    this.translateService.setDefaultLang("en");
    let language = localStorage.getItem("language")
      ? localStorage.getItem("language")
      : "en";
    this.translateService.use(language);
    this.route.params.subscribe((params) => {
      let transactionId = params["id"];
      this.fetchData(transactionId);
    });
  }

  ngOnInit() {}

  fetchData(transactionId) {    
    let self = this;
    self.crudService.get(
      null,
      function (response) {
        self.loading = false;
        if (
          response.error &&
          response.error.error &&
          response.error.error.message
        ) {
          self.toastr.error(response.error.error.message, "Invalid Operation");
        } else {
          self.data = response;
        }
      },
      "licenseHistories/getTransactionDetails?transactionId=" + transactionId
    );
  }

  getTransactionDateTime(timestamp: number): string {
    return new Date(timestamp * 1000).toLocaleString(); 
  }
}
